import { request } from './http';

export interface StudentCourseResponse {
	id: number;
	subjectId: number;
	subjectName: string;
	teacherName: string;
	code: string;
	resourceCount: number;
	enrolledAt: string;
}

export interface EnrollmentResponse {
	id: number;
	courseId: number;
	studentId: number;
	studentName: string;
	studentAvatarUrl: string | null;
	studentEmail: string;
	enrolledAt: string;
}

export const redeemCode = (code: string): Promise<StudentCourseResponse> =>
	request('/api/enrollments/redeem-code', {
		method: 'POST',
		body: JSON.stringify({ code }),
	});

export const listStudentCourses = (): Promise<StudentCourseResponse[]> =>
	request('/api/student/courses');

export const listTeacherEnrollments = (): Promise<EnrollmentResponse[]> =>
	request('/api/teacher/enrollments');

export const removeStudent = (courseId: number, studentId: number): Promise<void> =>
	request(`/api/teacher/courses/${courseId}/students/${studentId}`, { method: 'DELETE' });
